export default {
    'kl1-05003': 'deal1c_easy_set1',
    'kl1-00938': 'deal1c_easy_set1',
    'kl1-05040': 'deal1c_easy_set1',
    'kl1-00847': 'deal1c_easy_set1',
    'kl1-01309': 'deal1c_easy_set1',
    'kl1-00139': 'deal1c_easy_set1',
    'kl1-00305': 'deal1c_easy_set1',
    'kl1-00597': 'deal1c_easy_set1',
    'kl1-00351': 'deal1c_easy_set1',
    'kl1-00515': 'deal1c_easy_set1',
    'kl1-00403': 'deal1c_easy_set1',
    'kl1-04567': 'deal1c_easy_set1',
    'kl1-02922': 'deal1c_easy_set1',
    'kl1-01262': 'deal1c_easy_set1',
    'kl1-05354': 'deal1c_easy_set1',
    'kl1-05482': 'deal1c_easy_set1',
    'kl1-04477': 'deal1c_easy_set1',
    'kl1-04769': 'deal1c_easy_set1',
    'kl1-00828': 'deal1c_easy_set1',
    'kl1-00887': 'deal1c_easy_set1',
    'kl1-00111': 'deal1c_easy_set1',
    'kl1-04718': 'deal1c_easy_set1',
    'kl1-00690': 'deal1c_easy_set1',
    'kl1-05038': 'deal1c_easy_set1',
    'kl1-05324': 'deal1c_easy_set1',
    'kl1-00615': 'deal1c_easy_set1',
    'kl1-04889': 'deal1c_easy_set1',
    'kl1-03244': 'deal1c_easy_set1',
    'kl1-05302': 'deal1c_easy_set1',
    'kl1-03339': 'deal1c_easy_set1',
    'kl1-00119': 'deal1c_easy_set1',
    'kl1-04807': 'deal1c_easy_set1',
    'kl1-00125': 'deal1c_easy_set1',
    'kl1-02941': 'deal1c_easy_set1',
    'kl1-03105': 'deal1c_easy_set1',
    'kl1-00220': 'deal1c_easy_set1',
    'kl1-00869': 'deal1c_easy_set1',
    'kl1-03077': 'deal1c_easy_set1',
    'kl1-01194': 'deal1c_easy_set1',
    'kl1-05419': 'deal1c_easy_set1',
    'kl1-00748': 'deal1c_easy_set1',
    'kl1-00729': 'deal1c_easy_set1',
    'kl1-00227': 'deal1c_easy_set1',
    'kl1-00620': 'deal1c_easy_set1',
    'kl1-05022': 'deal1c_easy_set1',
    'kl1-00476': 'deal1c_easy_set1',
    'kl1-05286': 'deal1c_easy_set1',
    'kl1-03134': 'deal1c_easy_set1',
    'kl1-01290': 'deal1c_easy_set1',
    'kl1-00074': 'deal1c_easy_set1',
    'kl1-05221': 'deal1c_easy_set1',
    'kl1-00018': 'deal1c_easy_set1',
    'kl1-00130': 'deal1c_easy_set1',
    'kl1-04666': 'deal1c_easy_set1',
    'kl1-01260': 'deal1c_easy_set1',
    'kl1-01123': 'deal1c_easy_set1',
    'kl1-03259': 'deal1c_easy_set1',
    'kl1-03315': 'deal1c_easy_set1',
    'kl1-01305': 'deal1c_easy_set1',
    'kl1-00301': 'deal1c_easy_set1',
    'kl1-01320': 'deal1c_easy_set1',
    'kl1-00122': 'deal1c_easy_set1',
    'kl1-00043': 'deal1c_easy_set1',
    'kl1-05269': 'deal1c_easy_set1',
    'kl1-05156': 'deal1c_easy_set1',
    'kl1-04964': 'deal1c_easy_set1',
    'kl1-01052': 'deal1c_easy_set1',
    'kl1-05175': 'deal1c_easy_set1',
    'kl1-01075': 'deal1c_easy_set1',
    'kl1-00155': 'deal1c_easy_set1',
    'kl1-00827': 'deal1c_easy_set1',
    'kl1-02866': 'deal1c_easy_set1',
    'kl1-00600': 'deal1c_easy_set1',
    'kl1-01276': 'deal1c_easy_set1',
    'kl1-00518': 'deal1c_easy_set1',
    'kl1-00382': 'deal1c_easy_set1',
    'kl1-00641': 'deal1c_easy_set1',
    'kl1-03200': 'deal1c_easy_set1',
    'kl1-00142': 'deal1c_easy_set1',
    'kl1-05488': 'deal1c_easy_set1',
    'kl1-05001': 'deal1c_easy_set1',
    'kl1-03109': 'deal1c_easy_set1',
    'kl1-00352': 'deal1c_easy_set1',
    'kl1-00147': 'deal1c_easy_set1',
    'kl1-04989': 'deal1c_easy_set1',
    'kl1-05031': 'deal1c_easy_set1',
    'kl1-00421': 'deal1c_easy_set1',
    'kl1-00173': 'deal1c_easy_set1',
    'kl1-00662': 'deal1c_easy_set1',
    'kl1-00071': 'deal1c_easy_set1',
    'kl1-00272': 'deal1c_easy_set1',
    'kl1-01235': 'deal1c_easy_set1',
    'kl1-05173': 'deal1c_easy_set1',
    'kl1-00332': 'deal1c_easy_set1',
    'kl1-00771': 'deal1c_easy_set1',
    'kl1-03136': 'deal1c_easy_set1',
    'kl1-00325': 'deal1c_easy_set1',
    'kl1-00916': 'deal1c_easy_set1',
    'kl1-01169': 'deal1c_easy_set1',
    'kl1-01055': 'deal1c_easy_set1',
    'kl1-00603': 'deal1c_easy_set1',
    'kl1-00775': 'deal1c_easy_set1',
    'kl1-00202': 'deal1c_easy_set1',
    'kl1-05104': 'deal1c_easy_set1',
    'kl1-01295': 'deal1c_easy_set1',
    'kl1-01221': 'deal1c_easy_set1',
    'kl1-01163': 'deal1c_easy_set1',
    'kl1-03215': 'deal1c_easy_set1',
    'kl1-00224': 'deal1c_easy_set1',
    'kl1-00055': 'deal1c_easy_set1',
    'kl1-01135': 'deal1c_easy_set1',
    'kl1-01185': 'deal1c_easy_set1',
    'kl1-00808': 'deal1c_easy_set1',
    'kl1-00408': 'deal1c_easy_set1',
    'kl1-05427': 'deal1c_easy_set1',
    'kl1-03114': 'deal1c_easy_set1',
    'kl1-02964': 'deal1c_easy_set1',
    'kl1-00077': 'deal1c_easy_set1',
    'kl1-00823': 'deal1c_easy_set1',
    'kl1-00068': 'deal1c_easy_set1',
    'kl1-00395': 'deal1c_easy_set1',
    'kl1-05074': 'deal1c_easy_set1',
    'kl1-03190': 'deal1c_easy_set1',
    'kl1-00189': 'deal1c_easy_set1',
    'kl1-00605': 'deal1c_easy_set1',
    'kl1-00089': 'deal1c_easy_set1',
    'kl1-00824': 'deal1c_easy_set1',
    'kl1-00397': 'deal1c_easy_set1',
    'kl1-01108': 'deal1c_easy_set1',
    'kl1-02991': 'deal1c_easy_set1',
    'kl1-01247': 'deal1c_easy_set1',
    'kl1-00083': 'deal1c_easy_set1',
    'kl1-04977': 'deal1c_easy_set1',
    'kl1-03337': 'deal1c_easy_set1',
    'kl1-01281': 'deal1c_easy_set1',
    'kl1-05266': 'deal1c_easy_set1',
    'kl1-00223': 'deal1c_easy_set1',
    'kl1-00774': 'deal1c_easy_set1',
    'kl1-04614': 'deal1c_easy_set1',
    'kl1-00067': 'deal1c_easy_set1',
    'kl1-01035': 'deal1c_easy_set1',
    'kl1-00960': 'deal1c_easy_set1',
    'kl1-00866': 'deal1c_easy_set1',
    'kl1-05145': 'deal1c_easy_set1',
    'kl1-05334': 'deal1c_easy_set1',
    'kl1-05172': 'deal1c_easy_set1',
    'kl1-00186': 'deal1c_easy_set1',
    'kl1-00204': 'deal1c_easy_set1',
    'kl1-00203': 'deal1c_easy_set1',
    'kl1-05154': 'deal1c_easy_set1',
    'kl1-00084': 'deal1c_easy_set1',
    'kl1-01122': 'deal1c_easy_set1',
    'kl1-01156': 'deal1c_easy_set1',
    'kl1-00331': 'deal1c_easy_set1',
    'kl1-01086': 'deal1c_easy_set1',
    'kl1-04509': 'deal1c_easy_set1',
    'kl1-04883': 'deal1c_easy_set1',
    'kl1-02959': 'deal1c_easy_set1',
    'kl1-03286': 'deal1c_easy_set1',
    'kl1-03258': 'deal1c_easy_set1',
    'kl1-00751': 'deal1c_easy_set1',
    'kl1-04956': 'deal1c_easy_set1',
    'kl1-03043': 'deal1c_easy_set1',
    'kl1-05491': 'deal1c_easy_set1',
    'kl1-05150': 'deal1c_easy_set1',
    'kl1-04606': 'deal1c_easy_set1',
    'kl1-00792': 'deal1c_easy_set1',
    'kl1-04971': 'deal1c_easy_set1',
    'kl1-00730': 'deal1c_easy_set1',
    'kl1-04611': 'deal1c_easy_set1',
    'kl1-00463': 'deal1c_easy_set1',
    'kl1-00135': 'deal1c_easy_set1',
    'kl1-02919': 'deal1c_easy_set1',
    'kl1-05258': 'deal1c_easy_set1',
    'kl1-00144': 'deal1c_easy_set1',
    'kl1-05181': 'deal1c_easy_set1',
    'kl1-03333': 'deal1c_easy_set1',
    'kl1-00575': 'deal1c_easy_set1',
    'kl1-03210': 'deal1c_easy_set1',
    'kl1-01041': 'deal1c_easy_set1',
    'kl1-00468': 'deal1c_easy_set1',
    'kl1-00415': 'deal1c_easy_set1',
    'kl1-01288': 'deal1c_easy_set1',
    'kl1-00813': 'deal1c_easy_set1',
    'kl1-00329': 'deal1c_easy_set1',
    'kl1-05246': 'deal1c_easy_set1',
    'kl1-04739': 'deal1c_easy_set1',
    'kl1-00450': 'deal1c_easy_set1',
    'kl1-00409': 'deal1c_easy_set1',
    'kl1-04952': 'deal1c_easy_set1',
    'kl1-00387': 'deal1c_easy_set1',
    'kl1-05224': 'deal1c_easy_set1',
    'kl1-03316': 'deal1c_easy_set1',
    'kl1-00070': 'deal1c_easy_set1',
    'kl1-01296': 'deal1c_easy_set1',
    'kl1-00547': 'deal1c_easy_set1',
    'kl1-03307': 'deal1c_easy_set1',
    'kl1-02870': 'deal1c_easy_set1',

    'kl1-02980': 'deal1c_easy_set2',
    'kl1-01117': 'deal1c_easy_set2',
    'kl1-01206': 'deal1c_easy_set2',
    'kl1-01003': 'deal1c_easy_set2',
    'kl1-00039': 'deal1c_easy_set2',
    'kl1-05155': 'deal1c_easy_set2',
    'kl1-00030': 'deal1c_easy_set2',
    'kl1-04514': 'deal1c_easy_set2',
    'kl1-02989': 'deal1c_easy_set2',
    'kl1-00361': 'deal1c_easy_set2',
    'kl1-00781': 'deal1c_easy_set2',
    'kl1-00541': 'deal1c_easy_set2',
    'kl1-00487': 'deal1c_easy_set2',
    'kl1-04563': 'deal1c_easy_set2',
    'kl1-00036': 'deal1c_easy_set2',
    'kl1-00706': 'deal1c_easy_set2',
    'kl1-05327': 'deal1c_easy_set2',
    'kl1-03271': 'deal1c_easy_set2',
    'kl1-05197': 'deal1c_easy_set2',
    'kl1-01082': 'deal1c_easy_set2',
    'kl1-05382': 'deal1c_easy_set2',
    'kl1-04714': 'deal1c_easy_set2',
    'kl1-00459': 'deal1c_easy_set2',
    'kl1-05367': 'deal1c_easy_set2',
    'kl1-04485': 'deal1c_easy_set2',
    'kl1-04562': 'deal1c_easy_set2',
    'kl1-00896': 'deal1c_easy_set2',
    'kl1-05369': 'deal1c_easy_set2',
    'kl1-00614': 'deal1c_easy_set2',
    'kl1-00183': 'deal1c_easy_set2',
    'kl1-01190': 'deal1c_easy_set2',
    'kl1-04586': 'deal1c_easy_set2',
    'kl1-00944': 'deal1c_easy_set2',
    'kl1-00219': 'deal1c_easy_set2',
    'kl1-05110': 'deal1c_easy_set2',
    'kl1-02852': 'deal1c_easy_set2',
    'kl1-05054': 'deal1c_easy_set2',
    'kl1-00371': 'deal1c_easy_set2',
    'kl1-05284': 'deal1c_easy_set2',
    'kl1-00195': 'deal1c_easy_set2',
    'kl1-03072': 'deal1c_easy_set2',
    'kl1-04930': 'deal1c_easy_set2',
    'kl1-00915': 'deal1c_easy_set2',
    'kl1-05259': 'deal1c_easy_set2',
    'kl1-00236': 'deal1c_easy_set2',
    'kl1-05432': 'deal1c_easy_set2',
    'kl1-00631': 'deal1c_easy_set2',
    'kl1-04395': 'deal1c_easy_set2',
    'kl1-02969': 'deal1c_easy_set2',
    'kl1-00790': 'deal1c_easy_set2',
    'kl1-01088': 'deal1c_easy_set2',
    'kl1-05358': 'deal1c_easy_set2',
    'kl1-00633': 'deal1c_easy_set2',
    'kl1-05034': 'deal1c_easy_set2',
    'kl1-04482': 'deal1c_easy_set2',
    'kl1-05431': 'deal1c_easy_set2',
    'kl1-03033': 'deal1c_easy_set2',
    'kl1-01171': 'deal1c_easy_set2',
    'kl1-05319': 'deal1c_easy_set2',
    'kl1-00488': 'deal1c_easy_set2',
    'kl1-00923': 'deal1c_easy_set2',
    'kl1-00013': 'deal1c_easy_set2',
    'kl1-03174': 'deal1c_easy_set2',
    'kl1-00362': 'deal1c_easy_set2',
    'kl1-01162': 'deal1c_easy_set2',
    'kl1-00713': 'deal1c_easy_set2',
    'kl1-03322': 'deal1c_easy_set2',
    'kl1-00458': 'deal1c_easy_set2',
    'kl1-00446': 'deal1c_easy_set2',
    'kl1-01079': 'deal1c_easy_set2',
    'kl1-02975': 'deal1c_easy_set2',
    'kl1-00153': 'deal1c_easy_set2',
    'kl1-04697': 'deal1c_easy_set2',
    'kl1-04954': 'deal1c_easy_set2',
    'kl1-00296': 'deal1c_easy_set2',
    'kl1-00507': 'deal1c_easy_set2',
    'kl1-00306': 'deal1c_easy_set2',
    'kl1-00178': 'deal1c_easy_set2',
    'kl1-00090': 'deal1c_easy_set2',
    'kl1-00287': 'deal1c_easy_set2',
    'kl1-00302': 'deal1c_easy_set2',
    'kl1-01037': 'deal1c_easy_set2',
    'kl1-04440': 'deal1c_easy_set2',
    'kl1-00207': 'deal1c_easy_set2',
    'kl1-04547': 'deal1c_easy_set2',
    'kl1-05469': 'deal1c_easy_set2',
    'kl1-00221': 'deal1c_easy_set2',
    'kl1-03041': 'deal1c_easy_set2',
    'kl1-01239': 'deal1c_easy_set2',
    'kl1-03125': 'deal1c_easy_set2',
    'kl1-00694': 'deal1c_easy_set2',
    'kl1-00061': 'deal1c_easy_set2',
    'kl1-05251': 'deal1c_easy_set2',
    'kl1-00079': 'deal1c_easy_set2',
    'kl1-01069': 'deal1c_easy_set2',
    'kl1-04537': 'deal1c_easy_set2',
    'kl1-00430': 'deal1c_easy_set2',
    'kl1-00940': 'deal1c_easy_set2',
    'kl1-00107': 'deal1c_easy_set2',
    'kl1-01304': 'deal1c_easy_set2',
    'kl1-00170': 'deal1c_easy_set2',
    'kl1-00405': 'deal1c_easy_set2',
    'kl1-01228': 'deal1c_easy_set2',
    'kl1-01277': 'deal1c_easy_set2',
    'kl1-05397': 'deal1c_easy_set2',
    'kl1-04723': 'deal1c_easy_set2',
    'kl1-05465': 'deal1c_easy_set2',
    'kl1-00154': 'deal1c_easy_set2',
    'kl1-00128': 'deal1c_easy_set2',
    'kl1-00244': 'deal1c_easy_set2',
    'kl1-05115': 'deal1c_easy_set2',
    'kl1-03280': 'deal1c_easy_set2',
    'kl1-01005': 'deal1c_easy_set2',
    'kl1-01020': 'deal1c_easy_set2',
    'kl1-00091': 'deal1c_easy_set2',
    'kl1-00156': 'deal1c_easy_set2',
    'kl1-00634': 'deal1c_easy_set2',
    'kl1-01030': 'deal1c_easy_set2',
    'kl1-00457': 'deal1c_easy_set2',
    'kl1-05364': 'deal1c_easy_set2',
    'kl1-00187': 'deal1c_easy_set2',
    'kl1-00073': 'deal1c_easy_set2',
    'kl1-00249': 'deal1c_easy_set2',
    'kl1-00618': 'deal1c_easy_set2',
    'kl1-00309': 'deal1c_easy_set2',
    'kl1-04780': 'deal1c_easy_set2',
    'kl1-00286': 'deal1c_easy_set2',
    'kl1-04908': 'deal1c_easy_set2',
    'kl1-01115': 'deal1c_easy_set2',
    'kl1-00168': 'deal1c_easy_set2',
    'kl1-00262': 'deal1c_easy_set2',
    'kl1-01211': 'deal1c_easy_set2',
    'kl1-00136': 'deal1c_easy_set2',
    'kl1-00293': 'deal1c_easy_set2',
    'kl1-02861': 'deal1c_easy_set2',
    'kl1-02848': 'deal1c_easy_set2',
    'kl1-00545': 'deal1c_easy_set2',
    'kl1-05350': 'deal1c_easy_set2',
    'kl1-04775': 'deal1c_easy_set2',
    'kl1-03056': 'deal1c_easy_set2',
    'kl1-01028': 'deal1c_easy_set2',
    'kl1-00097': 'deal1c_easy_set2',
    'kl1-00177': 'deal1c_easy_set2',
    'kl1-03039': 'deal1c_easy_set2',
    'kl1-04876': 'deal1c_easy_set2',
    'kl1-01268': 'deal1c_easy_set2',
    'kl1-02891': 'deal1c_easy_set2',
    'kl1-00785': 'deal1c_easy_set2',
    'kl1-00679': 'deal1c_easy_set2',
    'kl1-03064': 'deal1c_easy_set2',
    'kl1-00328': 'deal1c_easy_set2',
    'kl1-00367': 'deal1c_easy_set2',
    'kl1-01184': 'deal1c_easy_set2',
    'kl1-00924': 'deal1c_easy_set2',
    'kl1-02997': 'deal1c_easy_set2',
    'kl1-00102': 'deal1c_easy_set2',
    'kl1-00035': 'deal1c_easy_set2',
    'kl1-01332': 'deal1c_easy_set2',
    'kl1-00377': 'deal1c_easy_set2',
    'kl1-00034': 'deal1c_easy_set2',
    'kl1-00006': 'deal1c_easy_set2',
    'kl1-00072': 'deal1c_easy_set2',
    'kl1-05118': 'deal1c_easy_set2',
    'kl1-00692': 'deal1c_easy_set2',
    'kl1-00509': 'deal1c_easy_set2',
    'kl1-00966': 'deal1c_easy_set2',
    'kl1-00776': 'deal1c_easy_set2',
    'kl1-04898': 'deal1c_easy_set2',
    'kl1-00063': 'deal1c_easy_set2',
    'kl1-05082': 'deal1c_easy_set2',
    'kl1-00417': 'deal1c_easy_set2',
    'kl1-00169': 'deal1c_easy_set2',
    'kl1-04728': 'deal1c_easy_set2',
    'kl1-00320': 'deal1c_easy_set2',
    'kl1-04773': 'deal1c_easy_set2',
    'kl1-01191': 'deal1c_easy_set2',
    'kl1-01251': 'deal1c_easy_set2',
    'kl1-00138': 'deal1c_easy_set2',
    'kl1-00994': 'deal1c_easy_set2',
    'kl1-02893': 'deal1c_easy_set2',
    'kl1-03108': 'deal1c_easy_set2',
    'kl1-01113': 'deal1c_easy_set2',
    'kl1-05021': 'deal1c_easy_set2',
    'kl1-00375': 'deal1c_easy_set2',
    'kl1-05462': 'deal1c_easy_set2',
    'kl1-03218': 'deal1c_easy_set2',
    'kl1-01172': 'deal1c_easy_set2',
    'kl1-04427': 'deal1c_easy_set2',
    'kl1-03188': 'deal1c_easy_set2',
    'kl1-03203': 'deal1c_easy_set2',
    'kl1-02905': 'deal1c_easy_set2',
    'kl1-00360': 'deal1c_easy_set2',
    'kl1-00121': 'deal1c_easy_set2',
    'kl1-05297': 'deal1c_easy_set2',
    'kl1-00237': 'deal1c_easy_set2',
    'kl1-01054': 'deal1c_easy_set2',
    'kl1-00002': 'deal1c_easy_set2',
    'kl1-02953': 'deal1c_easy_set2',
    'kl1-00184': 'deal1c_easy_set2',
    'kl1-04846': 'deal1c_easy_set2',

    'kl1-04842': 'deal1c_easy_set3',
    'kl1-00760': 'deal1c_easy_set3',
    'kl1-05381': 'deal1c_easy_set3',
    'kl1-01329': 'deal1c_easy_set3',
    'kl1-05398': 'deal1c_easy_set3',
    'kl1-00046': 'deal1c_easy_set3',
    'kl1-00027': 'deal1c_easy_set3',
    'kl1-05069': 'deal1c_easy_set3',
    'kl1-00941': 'deal1c_easy_set3',
    'kl1-00005': 'deal1c_easy_set3',
    'kl1-01285': 'deal1c_easy_set3',
    'kl1-00567': 'deal1c_easy_set3',
    'kl1-05107': 'deal1c_easy_set3',
    'kl1-01164': 'deal1c_easy_set3',
    'kl1-01215': 'deal1c_easy_set3',
    'kl1-00011': 'deal1c_easy_set3',
    'kl1-00088': 'deal1c_easy_set3',
    'kl1-00162': 'deal1c_easy_set3',
    'kl1-00868': 'deal1c_easy_set3',
    'kl1-04617': 'deal1c_easy_set3',
    'kl1-02894': 'deal1c_easy_set3',
    'kl1-01280': 'deal1c_easy_set3',
    'kl1-00739': 'deal1c_easy_set3',
    'kl1-01104': 'deal1c_easy_set3',
    'kl1-00627': 'deal1c_easy_set3',
    'kl1-04479': 'deal1c_easy_set3',
    'kl1-00722': 'deal1c_easy_set3',
    'kl1-04407': 'deal1c_easy_set3',
    'kl1-03238': 'deal1c_easy_set3',
    'kl1-00805': 'deal1c_easy_set3',
    'kl1-00379': 'deal1c_easy_set3',
    'kl1-00062': 'deal1c_easy_set3',
    'kl1-00004': 'deal1c_easy_set3',
    'kl1-04570': 'deal1c_easy_set3',
    'kl1-01127': 'deal1c_easy_set3',
    'kl1-00232': 'deal1c_easy_set3',
    'kl1-03272': 'deal1c_easy_set3',
    'kl1-00289': 'deal1c_easy_set3',
    'kl1-02955': 'deal1c_easy_set3',
    'kl1-00109': 'deal1c_easy_set3',
    'kl1-01000': 'deal1c_easy_set3',
    'kl1-03327': 'deal1c_easy_set3',
    'kl1-01066': 'deal1c_easy_set3',
    'kl1-01116': 'deal1c_easy_set3',
    'kl1-00964': 'deal1c_easy_set3',
    'kl1-00258': 'deal1c_easy_set3',
    'kl1-00675': 'deal1c_easy_set3',
    'kl1-05158': 'deal1c_easy_set3',
    'kl1-00384': 'deal1c_easy_set3',
    'kl1-01224': 'deal1c_easy_set3',
    'kl1-05210': 'deal1c_easy_set3',
    'kl1-05368': 'deal1c_easy_set3',
    'kl1-00025': 'deal1c_easy_set3',
    'kl1-00838': 'deal1c_easy_set3',
    'kl1-00276': 'deal1c_easy_set3',
    'kl1-01317': 'deal1c_easy_set3',
    'kl1-04720': 'deal1c_easy_set3',
    'kl1-00163': 'deal1c_easy_set3',
    'kl1-00052': 'deal1c_easy_set3',
    'kl1-04471': 'deal1c_easy_set3',
    'kl1-00798': 'deal1c_easy_set3',
    'kl1-04925': 'deal1c_easy_set3',
    'kl1-01152': 'deal1c_easy_set3',
    'kl1-00001': 'deal1c_easy_set3',
    'kl1-05138': 'deal1c_easy_set3',
    'kl1-05306': 'deal1c_easy_set3',
    'kl1-02972': 'deal1c_easy_set3',
    'kl1-00594': 'deal1c_easy_set3',
    'kl1-04812': 'deal1c_easy_set3',
    'kl1-00703': 'deal1c_easy_set3',
    'kl1-04915': 'deal1c_easy_set3',
    'kl1-00612': 'deal1c_easy_set3',
    'kl1-03127': 'deal1c_easy_set3',
    'kl1-04811': 'deal1c_easy_set3',
    'kl1-00777': 'deal1c_easy_set3',
    'kl1-00172': 'deal1c_easy_set3',
    'kl1-00190': 'deal1c_easy_set3',
    'kl1-02855': 'deal1c_easy_set3',
    'kl1-03204': 'deal1c_easy_set3',
    'kl1-00007': 'deal1c_easy_set3',
    'kl1-00167': 'deal1c_easy_set3',
    'kl1-01051': 'deal1c_easy_set3',
    'kl1-04934': 'deal1c_easy_set3',
    'kl1-04717': 'deal1c_easy_set3',
    'kl1-01310': 'deal1c_easy_set3',
    'kl1-01050': 'deal1c_easy_set3',
    'kl1-05174': 'deal1c_easy_set3',
    'kl1-01230': 'deal1c_easy_set3',
    'kl1-00825': 'deal1c_easy_set3',
    'kl1-04895': 'deal1c_easy_set3',
    'kl1-02977': 'deal1c_easy_set3',
    'kl1-04920': 'deal1c_easy_set3',
    'kl1-01298': 'deal1c_easy_set3',
    'kl1-04923': 'deal1c_easy_set3',
    'kl1-00992': 'deal1c_easy_set3',
    'kl1-00300': 'deal1c_easy_set3',
    'kl1-01227': 'deal1c_easy_set3',
    'kl1-00378': 'deal1c_easy_set3',
    'kl1-05311': 'deal1c_easy_set3',
    'kl1-00899': 'deal1c_easy_set3',
    'kl1-03216': 'deal1c_easy_set3',
    'kl1-00767': 'deal1c_easy_set3',
    'kl1-04404': 'deal1c_easy_set3',
    'kl1-03235': 'deal1c_easy_set3',
    'kl1-01110': 'deal1c_easy_set3',
    'kl1-05142': 'deal1c_easy_set3',
    'kl1-04490': 'deal1c_easy_set3',
    'kl1-04940': 'deal1c_easy_set3',
    'kl1-00185': 'deal1c_easy_set3',
    'kl1-01056': 'deal1c_easy_set3',
    'kl1-04540': 'deal1c_easy_set3',
    'kl1-00682': 'deal1c_easy_set3',
    'kl1-01195': 'deal1c_easy_set3',
    'kl1-01070': 'deal1c_easy_set3',
    'kl1-00394': 'deal1c_easy_set3',
    'kl1-00506': 'deal1c_easy_set3',
    'kl1-01011': 'deal1c_easy_set3',
    'kl1-00469': 'deal1c_easy_set3',
    'kl1-05065': 'deal1c_easy_set3',
    'kl1-00963': 'deal1c_easy_set3',
    'kl1-00815': 'deal1c_easy_set3',
    'kl1-05052': 'deal1c_easy_set3',
    'kl1-00982': 'deal1c_easy_set3',
    'kl1-00246': 'deal1c_easy_set3',
    'kl1-05226': 'deal1c_easy_set3',
    'kl1-05094': 'deal1c_easy_set3',
    'kl1-00530': 'deal1c_easy_set3',
    'kl1-01274': 'deal1c_easy_set3',
    'kl1-01053': 'deal1c_easy_set3',
    'kl1-00080': 'deal1c_easy_set3',
    'kl1-01087': 'deal1c_easy_set3',
    'kl1-00734': 'deal1c_easy_set3',
    'kl1-00891': 'deal1c_easy_set3',
    'kl1-01242': 'deal1c_easy_set3',
    'kl1-04679': 'deal1c_easy_set3',
    'kl1-01314': 'deal1c_easy_set3',
    'kl1-00791': 'deal1c_easy_set3',
    'kl1-01266': 'deal1c_easy_set3',
    'kl1-00003': 'deal1c_easy_set3',
    'kl1-01143': 'deal1c_easy_set3',
    'kl1-01081': 'deal1c_easy_set3',
    'kl1-00164': 'deal1c_easy_set3',
    'kl1-01299': 'deal1c_easy_set3',
    'kl1-04478': 'deal1c_easy_set3',
    'kl1-00310': 'deal1c_easy_set3',
    'kl1-03281': 'deal1c_easy_set3',
    'kl1-05444': 'deal1c_easy_set3',
    'kl1-00965': 'deal1c_easy_set3',
    'kl1-00131': 'deal1c_easy_set3',
    'kl1-00848': 'deal1c_easy_set3',
    'kl1-00667': 'deal1c_easy_set3',
    'kl1-00987': 'deal1c_easy_set3',
    'kl1-01008': 'deal1c_easy_set3',
    'kl1-04585': 'deal1c_easy_set3',
    'kl1-03302': 'deal1c_easy_set3',
    'kl1-00432': 'deal1c_easy_set3',
    'kl1-05199': 'deal1c_easy_set3',
    'kl1-00413': 'deal1c_easy_set3',
    'kl1-00834': 'deal1c_easy_set3',
    'kl1-03173': 'deal1c_easy_set3',
    'kl1-00400': 'deal1c_easy_set3',
    'kl1-01036': 'deal1c_easy_set3',
    'kl1-04959': 'deal1c_easy_set3',
    'kl1-01318': 'deal1c_easy_set3',
    'kl1-00877': 'deal1c_easy_set3',
    'kl1-01063': 'deal1c_easy_set3',
    'kl1-00104': 'deal1c_easy_set3',
    'kl1-00579': 'deal1c_easy_set3',
    'kl1-04405': 'deal1c_easy_set3',
    'kl1-05053': 'deal1c_easy_set3',
    'kl1-04452': 'deal1c_easy_set3',
    'kl1-00736': 'deal1c_easy_set3',
    'kl1-01126': 'deal1c_easy_set3',
    'kl1-01080': 'deal1c_easy_set3',
    'kl1-05072': 'deal1c_easy_set3',
    'kl1-05231': 'deal1c_easy_set3',
    'kl1-01034': 'deal1c_easy_set3',
    'kl1-00544': 'deal1c_easy_set3',
    'kl1-00595': 'deal1c_easy_set3',
    'kl1-00254': 'deal1c_easy_set3',
    'kl1-04852': 'deal1c_easy_set3',
    'kl1-01201': 'deal1c_easy_set3',
    'kl1-01016': 'deal1c_easy_set3',
    'kl1-00784': 'deal1c_easy_set3',
    'kl1-04439': 'deal1c_easy_set3',
    'kl1-01238': 'deal1c_easy_set3',
    'kl1-05123': 'deal1c_easy_set3',
    'kl1-05050': 'deal1c_easy_set3',
    'kl1-00946': 'deal1c_easy_set3',
    'kl1-05452': 'deal1c_easy_set3',
    'kl1-05366': 'deal1c_easy_set3',
    'kl1-00939': 'deal1c_easy_set3',
    'kl1-04865': 'deal1c_easy_set3',
    'kl1-01213': 'deal1c_easy_set3',
    'kl1-04558': 'deal1c_easy_set3',
    'kl1-01132': 'deal1c_easy_set3',
    'kl1-01106': 'deal1c_easy_set3',
    'kl1-00802': 'deal1c_easy_set3',
    'kl1-00926': 'deal1c_easy_set3',
    'kl1-04598': 'deal1c_easy_set3',
    'kl1-00878': 'deal1c_easy_set3',
    'kl1-01231': 'deal1c_easy_set3',
    'kl1-01133': 'deal1c_easy_set3',
    'kl1-04581': 'deal1c_easy_set3',
    'kl1-05451': 'deal1c_easy_set3',
    'kl1-00988': 'deal1c_easy_set3',
    'kl1-04676': 'deal1c_easy_set3',
    'kl1-00585': 'deal1c_easy_set3',
    'kl1-00768': 'deal1c_easy_set3',
    'kl1-05473': 'deal1c_easy_set3',
    'kl1-03131': 'deal1c_easy_set3',
    'kl1-01326': 'deal1c_easy_set3',
    'kl1-05304': 'deal1c_easy_set3',
    'kl1-01174': 'deal1c_easy_set3',
    'kl1-05106': 'deal1c_easy_set3',
    'kl1-03169': 'deal1c_easy_set3',
    'kl1-00504': 'deal1c_easy_set3',
    'kl1-00278': 'deal1c_easy_set3',
    'kl1-00666': 'deal1c_easy_set3',
    'kl1-01012': 'deal1c_easy_set3',
    'kl1-01337': 'deal1c_easy_set3',
    'kl1-00429': 'deal1c_easy_set3',
    'kl1-00314': 'deal1c_easy_set3',
    'kl1-00026': 'deal1c_easy_set3',
    'kl1-04753': 'deal1c_easy_set3',
    'kl1-01225': 'deal1c_easy_set3',
    'kl1-00174': 'deal1c_easy_set3',
    'kl1-00635': 'deal1c_easy_set3',
    'kl1-00411': 'deal1c_easy_set3',
    'kl1-00106': 'deal1c_easy_set3',
    'kl1-03137': 'deal1c_easy_set3',
};
